// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WF4q","fullView":"styles_fullView__1ZTV4"};